<section class="h-full flex flex-col gap-2 z-0 relative  p-2 lg:pl-0">

    <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2">
        <div class="flex flex-wrap flex-col sm:flex-row gap-2">
            <div class="relative">
                <input type="text" [(ngModel)]="search" (ngModelChange)="onSearch($event)" placeholder="Search.." class="pl-8" />
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                    class="absolute left-2 top-1/2 transform -translate-y-1/2 size-5">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                </svg>
            </div>
            <div class="min-w-48">
                <input type="text" name="time" id="time" [(ngModel)]="todayDate" [owlDateTime]="date" [readOnly]="true"
                    (ngModelChange)="onDateChange($event)" [owlDateTimeTrigger]="date" [selectMode]="'range'" />
                <owl-date-time [pickerType]="'calendar'" #date></owl-date-time>
            </div>
            <div>
                <select (change)="onSelectPaymentType()" [(ngModel)]="paymentType" id="inputStatus" class="min-w-48">
                    <option value="">Select Payment Type</option>
                    <option value="charge">Charge</option>
                    <option value="refund">Refund</option>
                </select>
            </div>
            <div class="min-w-48 max-w-48">
                <ng-select id="member" [notFoundText]="'No record found'" placeholder="Select Member" [clearable]="true"
                    [(ngModel)]="selectedMembers" (scrollToEnd)="onScroll()" [searchable]="true"
                    (search)="onMemberSearch($event)" (clear)="onClear()" (close)="onClose()"
                    (change)="onMembersChange($event)">
                    <ng-option *ngFor="let member of members" value="{{ member.id }}">
                        {{(member.displayName | titlecase)}}
                    </ng-option>
                </ng-select>
            </div>
        </div>
        <div *ngIf="transactions && transactions.length">
            <h1 class="text-xs text-nowrap text-left">Showing {{(numberOfRecords * currentPage) - (transactions.length !=
                numberOfRecords? (numberOfRecords
                -transactions.length) : 0) }} of {{totalResults }} entries
            </h1>
        </div>
        <div></div>
    </div>

    <div
        class="h-full overflow-hidden p-2 flex flex-col rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10">
        <div class="h-full w-full overflow-hidden rounded-md ring-1 ring-zinc-950/10 dark:ring-white/10">
            <div class="flow-root h-full overflow-y-auto">
                <div class="-my-2">
                    <div class="inline-block min-w-full py-2 align-middle">
                        <table class="min-w-full border-separate border-spacing-0">
                            <thead>
                                <tr>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        #
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Actions
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        User
                                    </th>
                                    <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Trip
                                    </th>
                                      <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Funding Source
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Card
                                    </th>
                                  
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Type
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Amount
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Refunded Amount
                                    </th>
                                       <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Processing Amount
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Initiated By
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Receipt Url
                                    </th>
                                    <th
                                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    Payment Id
                                </th>
                                <th
                                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    Order Id
                                </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Created At
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Status
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of transactions | paginate: { itemsPerPage:numberOfRecords, currentPage: currentPage, totalItems:totalResults}; let i=index"
                                    class="hover:bg-gray-950/5 dark:hover:bg-white/10">
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{i+1}}
                                    </td>
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                           <div class="inline-flex relative" *ngIf="item.type==='charge' && item.status !== 'failed' && (item.status !== 'approved')">
                                            <!-- *ngIf="!assign.isJClone" -->
                                            <a [appToolTip]="'More Actions'" href="javascript:void(0)"
                                             
                                                (click)="showActionButtons(i)"
                                                class="hover:text-zinc-950 dark:hover:text-white text-zinc-500 dark:text-zinc-400">
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                                    stroke="currentColor" class="w-5 h-5">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z" />
                                                </svg>
                                            </a>
                                            <div (outsideClick)="closeActionMenu($event)" outside-click
                                                *ngIf="selectedDropdownIndex === i && toggleActionButtons"
                                                class="absolute left-4 z-20 my-4 w-64 origin-top-left rounded-md bg-white dark:bg-zinc-900 shadow-lg border border-zinc-950/10 hover:border-zinc-950/20 dark:border-white/10 dark:hover:border-white/20 focus:outline-none"
                                                role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
                                                <!-- (addAdditionalNote)="addAdditionalNote(assign, i)" -->
                                                 <app-transaction-action-dropdown class="divide-y divide-zinc-950/10 dark:divide-white/10" 
                                                 [transaction]="item"
                                                 (refund)="openRefundModal(item)"
                                                 
                                                 ></app-transaction-action-dropdown>
                                              
                                            </div>
                                        </div>
                                    
                                    </td>
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <ng-container *ngIf="item.member" >
                                            {{item.member.displayName | titlecase}}
                                       </ng-container>
                                    </td>
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <ng-container *ngIf="item.trip" >
                                            {{item.trip.reference}}-{{item.trip.suffix}}
                                        </ng-container>
                                    </td>
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <ng-container *ngIf="item.fundingsource" >
                                            {{item.fundingsource?.title | titlecase}}
                                        </ng-container>
                                    </td>
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <span *ngIf="item.sourceDetails">
                                            <span class="text-zinc-600 dark:text-white">{{ item.sourceDetails?.cardBrand |
                                                titlecase }}</span>
                                            <span> ({{ (item.sourceDetails?.last4 | titlecase) || '' }})</span>
                                        </span>

                                    </td>
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <span [ngClass]="{
                                          'badge-success': item.type === 'charge',
                                          'badge-primary': item.type === 'refund'
                                        }">
                                            {{ (item.type | titlecase) || '' }}
                                        </span>
                                    </td>
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        ${{item.amount ? (item.amount / 100 | number:'1.2-2') : '0.00' }}
                                    </td>
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            <ng-container *ngIf="item.type==='charge'">
                                                ${{item.refundedMoney?.amount ? (item.refundedMoney.amount / 100 | number:'1.2-2') : '0.00' }}
                                            </ng-container>
                                    </td>
                                      <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        ${{calculateProcessingAmount(item) ? (calculateProcessingAmount(item) / 100 | number:'1.2-2') : '0.00' }}
                                    </td>
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <ng-container *ngIf="item.user" >
                                            {{item.user.name | titlecase}}
                                       </ng-container>
                                    </td>
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <a class="hover:text-primary" target="_blank" href="{{item.receiptUrl}}">{{item.receiptUrl || ''}}</a>
                                    </td>
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{item.squarePaymentId || ''}}
                                    </td>
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{item.squareOrderId || ''}}
                                    </td>
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{(item.createdAt |date:'MM/DD/YYYY hh:mm A') || ''}}
                                    </td>
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <span [ngClass]="{
                                              'badge-success': item?.status === 'completed' || item?.status === 'approved',
                                              'badge-warning': item?.status === 'pending',
                                              'badge-danger': item?.status === 'cancelled' || item?.status === 'failed'
                                            }">
                                            {{ (item?.status | titlecase) || '' }}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex justify-end">
            <pagination-controls (pageChange)="onPageChange($event)" class="pagination-controls"></pagination-controls>
        </div>
    </div>

</section>
<app-transaction-refund-modal *ngIf="transactionObj" [transaction]="transactionObj"  
  (closeModal)="onCloseRefundModal($event)"></app-transaction-refund-modal>